module.exports = __webpack_public_path__ + "37ba7b92/img/copy-icon.408fdb2d.svg";